import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IPaymentButtonSlice {
  disabled: boolean;
  priceLabel: string;
  paymentButtonHasAcceptedTerms: boolean;
  paymentButtonTermsErrorMessage: string | null;
  paymentButtonIsPadPaymentMethod: boolean;
  paymentButtonBillingCountryCode?: string | null;
}

export const createPaymentButtonSliceDefaultValues = (): IPaymentButtonSlice => ({
  disabled: false,
  priceLabel: '',
  paymentButtonHasAcceptedTerms: false,
  paymentButtonTermsErrorMessage: null,
  paymentButtonIsPadPaymentMethod: false,
  paymentButtonBillingCountryCode: null,
});

export const createPaymentButtonSlice: StateCreator<IPaymentButtonSlice> = () =>
  createPaymentButtonSliceDefaultValues();

export type PaymentButtonPageStore = UseBoundStore<StoreApi<IPaymentButtonSlice>>;

export const createPaymentButtonHooks = (pageStore: PaymentButtonPageStore) => {
  return {
    useDisabled: () => pageStore((store) => store.disabled),
    usePriceLabel: () => pageStore((store) => store.priceLabel),

    useHasAcceptedTerms: () => pageStore((store) => store.paymentButtonHasAcceptedTerms),
    useTermsErrorMessage: () => pageStore((store) => store.paymentButtonTermsErrorMessage),

    useIsPadPaymentMethod: () => pageStore((store) => store.paymentButtonIsPadPaymentMethod),
    useBillingCountryCode: () => pageStore((store) => store.paymentButtonBillingCountryCode),
  };
};

export type PaymentButtonHooks = ReturnType<typeof createPaymentButtonHooks>;
